
let Currency = ['USD ($)','AUD ($)','CAD ($)','EUD (€)','INR (₹)','JPY (¥)','MXN ($)','MYR (RM)','NOK (kr)','PAB (B/.)','SAR (﷼)','TWD ($)','CNY (¥)','HKD ($)','IDR (Rp)',
'NZD ($)','PHP (₱)','SGD ($)','KRW (₩)','THB (฿)','VND (₫)','AED (د.إ)' ];

let CurrencySymbol = ['$','$','$','€','₹','¥','$','RM','kr','B/.','﷼','$','¥','$','Rp','$','₱','$','₩','฿','₫','د.إ' ];

export default class Currencies {

  static CurrenciesList(value) {        // Returning List of Currencies
    return Currency[value];
  }

  static CurrencySymbol(value) {
    return CurrencySymbol[value];
  }

  static EntireCurrenciesList() {      // Returning Entire List of Currencies
    return Currency;
  }
}










